var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222 0C117 0 78 34.6875 78 128V656C78 677.75 84.375 693.438 94 705V752C94 778.438 115.562 800 142 800H206C232.438 800 254 778.438 254 752V736H546V752C546 778.438 567.562 800 594 800H658C684.438 800 706 778.438 706 752V705C715.625 693.438 722 677.75 722 656V144C722 74.3125 713.375 0 610 0H222ZM270 64H546C554.875 64 562 71.1875 562 80V112C562 120.812 554.875 128 546 128H270C261.188 128 254 120.812 254 112V80C254 71.1875 261.188 64 270 64ZM206 176H594C626 176 642 192 642 224V416C642 448 610.75 463 594 463L206 464C174 464 158 448 158 416V224C158 192 174 176 206 176ZM62 192C44.375 192 30 206.375 30 224V352C30 369.625 44.375 384 62 384V192ZM738 192V384C755.688 384 770 369.625 770 352V224C770 206.375 755.688 192 738 192ZM214 544C244.938 544 270 569.062 270 600C270 630.938 244.938 656 214 656C183.062 656 158 630.938 158 600C158 569.062 183.062 544 214 544ZM586 544C616.938 544 642 569.062 642 600C642 630.938 616.938 656 586 656C555.062 656 530 630.938 530 600C530 569.062 555.062 544 586 544Z",
    fill: "#062134"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBus);
export default __webpack_public_path__ + "static/media/ico_bus.daae36cc178d74ba4b8de1a92de9323e.svg";
export { ForwardRef as ReactComponent };